import React from 'react'
import styled from 'styled-components'

import { CompanyInfo } from '../constants'

const Wrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto 0 auto;

  .contacts-wrapper {
    padding: 0 3rem 3rem 3rem;
  }

  p {
    text-align: left;
  }

  .no-bullets {
    list-style-type: none;
  }
`

const { phone, phone2 } = CompanyInfo
const phone3 = '+7 (913) 442-99-99'

const ContactsPage = () => (
  <Wrapper>
    <div className="contacts-wrapper">
      <h1>Контакты</h1>
      <p>Акционерное общество «Белё»</p>
      <p>{CompanyInfo.address}</p>
      <p>ИНН: 1911007316</p>
      <p>ОГРН: 1081903000772</p>
      <p>Телефоны:</p>
      <ul className="no-bullets">
        <li>
          <a href={`tel:${phone}`}>{phone}</a>
        </li>
        <li>
          <a href={`tel:${phone2}`}>{phone2}</a>
        </li>
        <li>
          <a href={`tel:${phone3}`}>{phone3}</a>
        </li>
      </ul>
      <p>
        Эл. почта:
        <ul className="no-bullets">
          <li>
            <a href="mailto:ao.bele@yandex.ru">ao.bele@yandex.ru</a>
          </li>
        </ul>
      </p>
    </div>
  </Wrapper>
)

export default ContactsPage
